import React from 'react';
import QRCodeGeneratorLte from './QRCodeGeneratorLte';
import { deleteQrLabelCall } from 'features/qrLabel/deleteQrLabel';
import { updateQrLabelCall } from 'features/qrLabel/updateQrLabel';
import { createQrLabelCall } from 'features/qrLabel/createQrLabel';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import MultiLanguageForm from 'components/MultiLanguageForm';

const FormDetailsMultilang = ({ data, masked_id, close_modal }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { qr_label_list_load } = useSelector(state => state.user);

    // Build initial data for each language from the product label list
    const buildInitialData = () => {
        const langs = ['hr', 'en', 'sk', 'sv', 'cs'];
        const initial = {};
        langs.forEach(lang => {
            const item = data.find(d => d.masked_id === masked_id && d.lang === lang);
            initial[lang] = item || null;
        });
        return initial;
    };

    const initialData = buildInitialData();

    // Handle saving all language versions
    const handleSave = (payload) => {
        payload.forEach(entry => {
            // Find existing entry for this language
            const existing = data.find(
                d => d.masked_id === masked_id && d.lang === entry.lang
            );
            if (existing) {
                // Update existing entry
                dispatch(updateQrLabelCall({ id: existing.id, ...entry }));
            } else if (entry.name || entry.ingredients) {
                // Create new language entry only if meaningful data present
                dispatch(createQrLabelCall({ masked_id: masked_id, ...entry }));
            }
        });
        close_modal();
    };

    // Delete the whole product (all languages)
    const handleDelete = () => {
        const anyEntry = data.find(d => d.masked_id === masked_id);
        if (anyEntry) {
            dispatch(deleteQrLabelCall({ id: anyEntry.id }));
        }
        close_modal();
    };

    // Get a display name for the QR code from any available language
    const displayName =
        initialData.hr?.name ||
        initialData.en?.name ||
        initialData.sk?.name ||
        initialData.sv?.name ||
        initialData.cs?.name ||
        '';

    // Get an item ID for the QR code (from any existing entry)
    const itemId = data.find(d => d.masked_id === masked_id)?.id;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            <QRCodeGeneratorLte maskedId={masked_id} name={displayName} itemid={itemId} />

            <MultiLanguageForm
                initialData={initialData}
                onSave={handleSave}
                isLoading={qr_label_list_load}
            />

            <div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'center' }}>
                <button className="btn btn-danger" onClick={handleDelete}>
                    {t('delete')}
                </button>
                <button className="btn btn-secondary" onClick={close_modal}>
                    {t('close')}
                </button>
            </div>
        </div>
    );
};

export default FormDetailsMultilang;